import { render, staticRenderFns } from "./LivePreviewIframe.vue?vue&type=template&id=12adcf0e&scoped=true&"
import script from "./LivePreviewIframe.vue?vue&type=script&lang=js&"
export * from "./LivePreviewIframe.vue?vue&type=script&lang=js&"
import style0 from "./LivePreviewIframe.vue?vue&type=style&index=0&id=12adcf0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12adcf0e",
  null
  
)

export default component.exports